import { Getters } from 'vuex-smart-module';
import ProjectDetailsState from './state';

export default class ProjectDetailsGetters extends Getters<ProjectDetailsState> {}
